import { useTrans } from "../../../hooks";
import {
    Box,
    Center,
    Divider,
    HStack,
    Input,
    useBreakpointValue,
    VStack,
} from "@chakra-ui/react";
import { AppPageHeader } from "../../../components";
import { DonationTransactionList as ListComponent } from "./DonationTransactionList";
import { useDonationTransactionCrud } from "./useDonationTransactionCrud";
import { useParams } from "react-router-dom";
import { DonationTransactionDetailView } from "./DonationTransactionDetailView";
import { AppSearch } from "../../../containers";

export const DonationTransactionPage = () => {
    // hook
    const shouldShowDivider = useBreakpointValue({ base: false, lg: true });
    const { t } = useTrans();
    const { id } = useParams();
    const {
        kaTableProps,
        actionOptions,
        actionClickHandler,
        formContainerState,
        data,
        loading,
        setSearch,
        startTime,
        endTime,
        setStartTime,
        setEndTime,
    } = useDonationTransactionCrud(id || "");

    return (
        <>
            <AppPageHeader
                title={t("padm.DonationTransactionPage:text.pageTitle")}
            >
                <HStack
                    gap={4}
                    py={{ base: 3.5, sm: 4, md: "1.125rem" }}
                    flexWrap={"wrap"}
                >
                    <Box
                        position={"relative"}
                        minW={{ base: "100%", sm: "12.5rem", md: "12.5rem" }}
                    >
                        <Input
                            type="date"
                            value={startTime}
                            onChange={(e) => setStartTime(e.target.value)}
                        />
                        <span
                            style={{
                                fontSize: "8px",
                                position: "absolute",
                                top: -5,
                                left: 10,
                                background: "var(--chakra-colors-white)",
                                padding: "0 8px",
                            }}
                        >
                            {t(
                                "padm.DonationTransactionPage:placeholder.startTime"
                            )}
                        </span>
                    </Box>
                    <Box
                        position={"relative"}
                        minW={{ base: "100%", sm: "12.5rem", md: "12.5rem" }}
                    >
                        <Input
                            type="date"
                            value={endTime}
                            onChange={(e) => setEndTime(e.target.value)}
                        />
                        <span
                            style={{
                                fontSize: "8px",
                                position: "absolute",
                                top: -5,
                                left: 10,
                                background: "var(--chakra-colors-white)",
                                padding: "0 8px",
                            }}
                        >
                            {t(
                                "padm.DonationTransactionPage:placeholder.endTime"
                            )}
                        </span>
                    </Box>
                    {shouldShowDivider && (
                        <Center height="2.1875rem">
                            <Divider
                                orientation="vertical"
                                borderColor={"var(--chakra-colors-greyT80)"}
                            />
                        </Center>
                    )}
                    <Box minW={"11.25rem"}>
                        <AppSearch onSearch={(value) => setSearch(value)} />
                    </Box>
                </HStack>
            </AppPageHeader>
            <VStack p={6}>
                <ListComponent
                    kaTableProps={kaTableProps}
                    actionOptions={actionOptions}
                    actionClickHandler={actionClickHandler}
                />
            </VStack>
            {formContainerState.isOpen && (
                <DonationTransactionDetailView
                    formContainerState={formContainerState}
                    data={data}
                    loading={loading}
                />
            )}
        </>
    );
};
